/**
 * Wraps the whole app. It sits outside ChakraProvider, so the fallback cannot
 * rely on Chakra being available; it renders plain markup like AppLoader does.
 * Errors are reported to Datadog RUM.
 */
import { datadogRum } from '@datadog/browser-rum';
import React from 'react';
import style from './ErrorBoundary.module.css';

interface IErrorBoundaryState {
	hasError: boolean;
}

export default class ErrorBoundary extends React.Component<React.PropsWithChildren, IErrorBoundaryState> {
	state: IErrorBoundaryState = { hasError: false };

	static getDerivedStateFromError(): IErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		datadogRum.addError(error, { componentStack: errorInfo.componentStack });
	}

	render() {
		if (!this.state.hasError) {
			return this.props.children;
		}

		return (
			<div data-testid="error-boundary" className={style.ErrorBoundary}>
				<p className={style.ErrorBoundary__Title}>Something went wrong</p>
				<p>If the problem persists write to info@timetime.in to get support 🙏</p>
			</div>
		);
	}
}
